<div class="edit-representative-container" *ngIf="member">
    <!--    <div *ngIf="canBeInvited" class="not-invited">-->
    <!--        <div class="mb-20">{{'This member has not received invitation yet.'|i18n}}</div>-->
    <!--        <button app-ghost-button (click)="onClickSendInvitation()">-->
    <!--            {{'Send invitation now'|i18n}}-->
    <!--        </button>-->
    <!--    </div>-->
    <!--    <div *ngIf="!enableInvitation && !canBeInvited" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px"-->
    <!--         class="mb-40">-->
    <!--        <div fxFlex="22"></div>-->
    <!--        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="info-panel mt-20">-->
    <!--            <app-icon name="fas-info-circle"></app-icon>-->
    <!--            <div>{{'To be able to send the invitation please enter email and phone number'|i18n}}</div>-->
    <!--        </div>-->
    <!--        <div fxFlex="22"></div>-->
    <!--    </div>-->
    <form [formGroup]="form" fxLayout="column">
        <div fxLayout="column" class="mt-52" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Type of subject'|i18n) + ':*' }}</div>
                <mat-select app-small-select formControlName="representativeType"
                            placeholder="{{'Type of subject'|i18n}}"
                            [disabled]="!!member.representative_type">
                    <mat-option *ngFor="let representativeType of representativeTypes" [value]="representativeType">
                        <div>{{ representativeType|genericPipe }}</div>
                    </mat-option>
                </mat-select>
                <div fxFlex="20"></div>
            </div>
            <div *ngIf="hasCompany" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Company name'|i18n) + ':*' }}</div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="companyName" [maxLength]="DEFAULT_MAX_CHARS">
                    <div *ngIf="invalidCompanyName" app-error>{{ 'Invalid company name'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
            <div *ngIf="!hasCompany" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Tax number'|i18n) + ':' }}</div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="cf" [maxLength]="TAX_ID_MAX_CHARS">
                    <div *ngIf="invalidTaxNumber" app-error>{{ 'Invalid tax number'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
            <div *ngIf="hasCompany" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('VAT num.'|i18n) + ':' }}</div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="piva" [maxLength]="VAT_NUMBER_MAX_CHARS">
                    <div *ngIf="invalidVatNumber" app-error>{{ 'Invalid vat number'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Name'|i18n) + ':*' }}</div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="firstName" [maxLength]="NAME_MAX_CHARS">
                    <div *ngIf="invalidFirstName" app-error>{{ 'Invalid name'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Surname'|i18n) + ':*' }}</div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="lastName" [maxLength]="NAME_MAX_CHARS">
                    <div *ngIf="invalidLastName" app-error>{{ 'Invalid surname'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="mt-10">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Email'|i18n) + ':*' }}</div>
                <!-- email can't be edited after the member is registered (due to it being used as onboarded user's username) -->
                <div fxFlex>{{ member.personal_data.email }}</div>
                <div fxFlex="20"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" class="mt-10">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">{{ ('Mobile'|i18n) + ':*' }}</div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="mobile" [maxLength]="MOBILE_MAX_CHARS">
                    <div *ngIf="invalidMobile" app-error>{{ 'Invalid mobile number'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
        </div>
        <div class="mt-48" fxLayout="row" fxLayoutGap="30px">
            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="app-section-title">
                {{ 'Address'|i18n }}
            </div>
        </div>
        <div fxLayout="column" fxLayoutGap="20px" class="mt-20">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">
                    {{ ('Address'|i18n) + ':' }}
                </div>
                <div fxFlex>
                    <app-google-maps-address-autocomplete [formControlRef]="addressFormControl"
                                                          [isRequired]="false"
                                                          [requiresGooglePlace]="false"
                                                          (addressChange)="addressChange($event)"
                                                          [restrictSearch]="true">
                    </app-google-maps-address-autocomplete>
                </div>
                <div fxFlex="20"></div>
            </div>
        </div>
        <div class="mt-48" fxLayout="row" fxLayoutGap="30px">
            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="app-section-title">
                {{ 'Contacts'|i18n }}
            </div>
        </div>
        <div fxLayout="column" fxLayoutGap="20px" class="mt-20">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">
                    {{ ('Phone'|i18n) + ':' }}
                </div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="phone" [maxLength]="MOBILE_MAX_CHARS">
                    <div *ngIf="invalidPhone" app-error>{{ 'Invalid phone number'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30" class="t-right">
                    {{ ('PEC'|i18n) + ':' }}
                </div>
                <div fxFlex app-input-container>
                    <input class="input-font" app-input formControlName="pec" [maxLength]="EMAIL_MAX_CHARS">
                    <div *ngIf="invalidPec" app-error>{{ 'Invalid PEC'|i18n }}</div>
                </div>
                <div fxFlex="20"></div>
            </div>
        </div>
        <div class="mt-48"></div>
    </form>
</div>
